import { firestore, myFbCollecionVisits } from "../Utils/fbFunctionInit";
export const formatTimestamp = (timestamp) => {
  // time stamp like "2024-11-27T11:33:57.936Z"
  const date = new Date(timestamp);
  // Extract individual date and time components
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // Combine components into a readable format
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export function toEnglishNumber(strNum = "") {
  var ar = "٠١٢٣٤٥٦٧٨٩".split("");
  var en = "0123456789".split("");
  strNum = strNum.toString().replace(/[٠١٢٣٤٥٦٧٨٩]/g, (x) => en[ar.indexOf(x)]);
  // strNum = strNum.replace(/[^\d]/g, "");
  return strNum;
}

export function calculateAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (m < 0) {
    m = m + 12;
  }
  // return age;
  // console.log("the age, months", age, m);
  return [age, m];
}

export function calculateTotalPrice(services, servicePrices) {
  let totalPrice = 0;
  Object.entries(services).forEach(([serviceName, isSelected]) => {
    if (isSelected) {
      if (serviceName === "Unpaid") {
        totalPrice -= servicePrices[serviceName];
      } else {
        totalPrice += servicePrices[serviceName];
      }
    }
  });
  return totalPrice;
}

export function calculateTotalPriceAll(services, servicePrices) {
  let totalPrice = 0;
  Object.entries(services).forEach(([serviceName, isSelected]) => {
    if (isSelected) {
      if (serviceName !== "Unpaid") {
        totalPrice += servicePrices[serviceName];
      }
    }
  });
  return totalPrice;
}

export function formatTime(timeLanguage, timeStr) {
  // timeLanguage for example "ar-EG" or "en-US"
  // Split the time string into hours and minutes
  const [hoursStr, minutesStr] = timeStr.split(":");

  // Extract the hours and minutes as numbers
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // Adjust the hours for PM times
  if (timeStr.indexOf("pm") !== -1 && hours < 12) {
    hours += 12;
  }

  // Create a new Date object with the adjusted hours and minutes
  const time = new Date();
  time.setHours(hours);
  time.setMinutes(minutes);

  // Format the time string using toLocaleTimeString()
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  return time.toLocaleTimeString(timeLanguage, options);
}

// export function formatDate(dateLanguage, dateString) {
//   // dateLanguage for example "ar-EG" or "en-US"

//   const date = new Date(dateString);
//   const options = {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   };
//   return date.toLocaleDateString(dateLanguage, options);
// }

export function formatDate(dateLanguage, dateString) {
  const date = new Date(dateString);
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formatter = new Intl.DateTimeFormat(dateLanguage, options);
  return formatter.format(date);
}

export function convertTimeTo24HourFormat(timeString) {
  const [time, period] = timeString.split(" ");
  let [hours, minutes] = time.split(":");
  if (period === "pm") {
    hours = parseInt(hours, 10) + 12;
  }
  hours = hours.toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

export function editObject(
  docId,
  timeSlot,
  ptMedRNToEdit,
  newObjectProperties
) {
  console.log(
    "editObject",
    docId,
    timeSlot,
    ptMedRNToEdit,
    newObjectProperties
  );
  // const docRef = firebase.firestore().collection('your-collection').doc('your-document-id');
  const docRef = firestore.collection(myFbCollecionVisits).doc(docId);

  docRef.get().then((doc) => {
    if (doc.exists) {
      const objects = doc.data().objects;

      if (objects[timeSlot]) {
        objects[timeSlot] = objects[timeSlot].map((obj) => {
          if (obj.ptMedRN === ptMedRNToEdit) {
            return { ...obj, ...newObjectProperties };
          }
          return obj;
        });

        docRef.update({ objects });
      }
    }
  });
}

// Helper function to determine if a color is light or dark using Hex colors
export const isColorLightHex = (color) => {
  // Convert hex color to RGB
  let r, g, b;
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    // Assume the color is in rgb format (e.g., "rgb(255, 255, 255)")
    [r, g, b] = color
      .replace("rgb(", "")
      .replace(")", "")
      .split(",")
      .map(Number);
  }

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5; // Returns true if light, false if dark
};

export const jsonParseFromLocalStorage = (localStorageItem, defaultValue) => {
  try {
    const item = localStorage.getItem(localStorageItem);
    // Check if item exists and is not null
    if (item) {
      return JSON.parse(item);
    } else {
      return defaultValue; // Return default value if item doesn't exist
    }
  } catch (error) {
    console.error("Error parsing JSON from localStorage:", error);
    return defaultValue; // Return default value if JSON parsing fails
  }
};

export const compressImage = (blob, maxFileSize) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const MAX_WIDTH = 800; // You can change this to control the image resolution
        const MAX_HEIGHT = 800; // You can change this to control the image resolution

        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio while resizing
        if (width > height) {
          if (width > MAX_WIDTH) {
            height = (height * MAX_WIDTH) / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width = (width * MAX_HEIGHT) / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        let quality = 0.9; // Initial quality factor
        let compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
        let compressedBlob = dataURLToBlob(compressedDataUrl);

        const compress = () => {
          // Check if compressed blob is still larger than the max file size
          if (compressedBlob.size > maxFileSize && quality > 0.1) {
            quality -= 0.05; // Reduce quality by 5%
            compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
            compressedBlob = dataURLToBlob(compressedDataUrl);
            compress(); // Recurse until file size is below limit
          } else {
            resolve(compressedBlob);
          }
        };

        compress();
      };

      img.onerror = (error) => reject(error);
    };

    reader.onerror = (error) => reject(error);
  });
};

export const dataURLToBlob = (dataUrl) => {
  const byteString = atob(dataUrl.split(",")[1]);
  const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const validateAndFormatPhoneNumber = (phoneNumber) => {
  // Remove any non-digit characters
  let sanitizedNumber = phoneNumber.replace(/\D/g, "");

  // Remove the leading '0' if it exists
  if (sanitizedNumber.startsWith("0")) {
    sanitizedNumber = sanitizedNumber.slice(1);
  }

  // Define the Egyptian country code
  const egyptianCountryCode = "+20";

  // Validate if the number is already in international format
  if (phoneNumber.startsWith(egyptianCountryCode)) {
    // Ensure the length of the number is valid
    if (sanitizedNumber.length === 12) {
      return egyptianCountryCode + sanitizedNumber.slice(2); // Return the formatted international number
    } else {
      return null; // Invalid length for Egyptian number
    }
  }

  // Check if the number is a valid local Egyptian number
  const localPattern = /^(1[0-25]\d{8})$/; // Example for Egyptian mobile numbers without the leading '0'
  if (localPattern.test(sanitizedNumber)) {
    // Add the Egyptian country code
    return egyptianCountryCode + sanitizedNumber;
  }

  return null; // Invalid number
};
